const MiniNavbar = () => (
  <header style={{ background: "#fff", borderBottom: "1px solid #f0e6dc", padding: "1rem 2rem" }} data-testid="legal-navbar">
    <a href="/" style={{ fontFamily: "'Playfair Display',serif", fontSize: "1.2rem", fontWeight: 700, color: "#1A1A1A", textDecoration: "none" }}>
      SelfieBooth Event
    </a>
  </header>
);

const GOLD = "#B8977E";

const styles = {
  page: { background: "#faf8f5", minHeight: "100vh", display: "flex", flexDirection: "column" },
  container: { maxWidth: 820, margin: "0 auto", padding: "4rem 2rem", width: "100%", flex: 1 },
  h1: { fontFamily: "'Playfair Display',serif", fontSize: "clamp(2rem, 4vw, 2.6rem)", fontWeight: 700, color: "#1A1A1A", marginBottom: "0.4rem", lineHeight: 1.15 },
  subtitle: { fontFamily: "'Cormorant Garamond',serif", fontStyle: "italic", color: "#8a7a70", fontSize: "1.05rem", marginBottom: "2.5rem" },
  h2: { fontFamily: "'Playfair Display',serif", fontSize: "1.5rem", fontWeight: 700, color: "#1A1A1A", marginTop: "2.5rem", marginBottom: "1rem", paddingBottom: "0.5rem", borderBottom: `2px solid ${GOLD}`, width: "fit-content", minWidth: 60 },
  h3: { fontFamily: "'DM Sans',sans-serif", fontSize: "1.05rem", fontWeight: 700, color: GOLD, marginTop: "1.5rem", marginBottom: "0.5rem" },
  p: { fontFamily: "'DM Sans',sans-serif", color: "#1A1A1A", fontSize: "0.95rem", lineHeight: 1.75, marginBottom: "0.75rem" },
  table: { width: "100%", borderCollapse: "collapse", margin: "1rem 0", fontSize: "0.9rem", fontFamily: "'DM Sans',sans-serif", border: "1px solid #f0e6dc" },
  th: { background: "#f5ede8", color: "#1A1A1A", padding: "12px 16px", textAlign: "left", fontWeight: 700, borderBottom: "1px solid #f0e6dc" },
  td: { padding: "12px 16px", borderTop: "1px solid #f0e6dc", color: "#1A1A1A", verticalAlign: "top" },
  ul: { paddingLeft: "1.25rem", marginBottom: "0.75rem" },
  li: { fontFamily: "'DM Sans',sans-serif", color: "#1A1A1A", fontSize: "0.95rem", lineHeight: 1.75, marginBottom: "0.35rem", listStyle: "none", position: "relative" },
  liBullet: { position: "absolute", left: "-1.1rem", color: GOLD, fontWeight: 700 },
  strong: { fontWeight: 700, color: "#1A1A1A" },
};

export const LegalLayout = ({ title, subtitle, children }) => (
  <div style={styles.page} data-testid="legal-page-layout">
    <MiniNavbar />
    <div style={styles.container}>
      <h1 style={styles.h1}>{title}</h1>
      <p style={styles.subtitle}>{subtitle}</p>
      <div>{children}</div>
    </div>
  </div>
);

export const H2 = ({ children }) => <h2 style={styles.h2}>{children}</h2>;
export const H3 = ({ children }) => <h3 style={styles.h3}>{children}</h3>;
export const P = ({ children }) => <p style={styles.p}>{children}</p>;
export const Strong = ({ children }) => <strong style={styles.strong}>{children}</strong>;
export const UL = ({ children }) => <ul style={styles.ul}>{children}</ul>;
export const LI = ({ children }) => (
  <li style={styles.li}>
    <span style={styles.liBullet}>◆</span>{children}
  </li>
);
export const Table = ({ head, rows }) => (
  <div style={{ overflowX: "auto" }}>
    <table style={styles.table}>
      <thead>
        <tr>{head.map((h, i) => <th key={i} style={styles.th}>{h}</th>)}</tr>
      </thead>
      <tbody>
        {rows.map((row, i) => (
          <tr key={i}>{row.map((cell, j) => <td key={j} style={styles.td}>{cell}</td>)}</tr>
        ))}
      </tbody>
    </table>
  </div>
);
